import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SessionModule } from '../session/session.module';
import { ProfileService } from './profile.service';

/**
 * Profile Module.
 */
@NgModule({
  declarations: [],
  imports: [CommonModule, SessionModule],
  providers: [ProfileService]
})
export class ProfileModule {}
